import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom-v5-compat";
import menuData from "../../assets/data/menu.json";
import PermissionList from "../../assets/data/permissionList.json";
import caretArrow from '../../assets/images/download.png';
import backArrow from '../../assets/images/back_icon.png';
import './style.scss';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loginAction, editClientData, refreshUserAction } from '../../store/actions';

const SideMenu = (props) => {

  let [navs, setNavs] = useState([]);

  useEffect(() => {
    const { permissions } = props.UserReducer;
    let userPermissions = permissions?.filter(p => p.isActive)?.map(p => p.key);
    let permissionList = PermissionList.filter(p => userPermissions?.includes(p.key));
    let menu = menuData.filter(item => {
      return checkAccess(item, permissionList);
    });
    setNavs([...menu])
  }, [props.UserReducer.permissions, props.UserReducer.LOGIN_AS, props.UserReducer.companyName, props.UserReducer.role]);

  function openCloseNav(e, i) {
    e.stopPropagation();
    e.preventDefault();
    let updateNavs = [...navs];
    updateNavs[i].showSubs = !updateNavs[i].showSubs;
    setNavs(updateNavs);
  };

  //pIx = parent index; nIx = sub index;
  function openCloseSub(e, pIx, nIx) {
    e.stopPropagation();
    e.preventDefault();
    let updateNavs = [...navs];
    updateNavs[pIx].subs[nIx].showSubs = !updateNavs[pIx].subs[nIx].showSubs;
    setNavs(updateNavs);
  }

  function checkAccess(menuItem, permissionList) {
    if (menuItem.openAccess) return true;
    let isKey = permissionList.find(p => p.key === menuItem.key);
    let isGroupKey = permissionList.find(p => p.group === menuItem.key);
    if (isKey) return true;

    if (isGroupKey && menuItem.groupHeader) {
      if (menuItem.subItems) {
        menuItem.subs = menuItem.subItems.filter(sub => checkAccess(sub, permissionList));
        return menuItem.subs.length;
      };
      return true;
    }
    return false
  };

  return (
    <div className={`left-sidebar ${props.className}`} onMouseEnter={props.hoverOn} onMouseLeave={props.hoverOff} >
      {(props.UserReducer.LOGIN_AS) && (
        <>
          <button className="back_btn" onClick={props.backAdmin}>
            <span className="menu-label df">
              <span className="icon-svg">
                <img src={backArrow} alt="" />
              </span>
              <span className="menu-label-text"> Back to admin </span>
            </span>
          </button>
        </>
      )}
      <ul className="list-group">
        {navs?.map((nav, ix) => {
          return (
            <span key={ix}>
              {!nav.hidden && (
                <li className="list-group-item" key={`${ix}-li`}>
                  <div className="nav_wrpr" key={`${ix}-nav`}>
                    <NavLink
                      end
                      className={({ isActive }) => isActive ? "active" : `${nav.className}`}
                      to={nav.url}
                      key={`${ix}-nl${ix}`}
                    >
                      {nav.subs?.length > 0 ?
                        <span className={`menu-label df has-menu  ${nav.showSubs ? "open" : ""} `}
                          onClick={(e) => { openCloseNav(e, ix) }} >
                          <span className="icon-svg">
                            <img src={nav.navIcon} alt="" />
                          </span>
                          <span className="menu-label-text"> {nav.label} </span>
                          <div className={`df  expand`}><img stc={caretArrow} alt="" /></div>
                        </span> :
                        <span className={`menu-label df  ${nav.showSubs ? "open" : ""}`}>
                          <span className="icon-svg gg">
                            <img src={nav.navIcon} alt="" />
                          </span>
                          <span className="menu-label-text">  {nav.label} </span>
                        </span>}

                    </NavLink>
                    {nav.showSubs && (
                      <div className="subMenu">
                        {nav.subs.map((sub, idx) => {
                          return (
                            <>
                              <span key={`${idx}-sub`}>
                                {!sub.hidden && (
                                  <>
                                    <NavLink
                                      key={`${ix}_${idx}`}
                                      end
                                      data-itm="home"
                                      className={({ isActive }) => isActive ? "active" : "df fs12 ffmm fwm sub_nav"}
                                      to={sub.url}
                                    >
                                      {sub.subs?.length ?
                                        <span className={`menu-label df has-menu  ${sub.showSubs ? "open" : ""} `}
                                          onClick={(e) => { openCloseSub(e, ix, idx) }} >
                                          <span className="menu-label-text"> {sub.label} </span>
                                          <div className={`df  expand`}><img stc={caretArrow} alt="" /></div>
                                        </span> :
                                        <span className={`menu-label df  ${sub.showSubs ? "open" : ""}`}>
                                          <span className="menu-label-text">  {sub.label}</span>
                                        </span>}

                                    </NavLink>
                                    {sub.subs?.length ?
                                      <div className="subMenu third-bar">
                                        {sub.showSubs && (
                                          sub.subs.map((subItem, idxx) => (
                                            <NavLink
                                              key={idxx + '_sub_sub'}
                                              end
                                              className={({ isActive }) => isActive ? "active" : `${nav.className}`}
                                              to={subItem.url}
                                            >
                                              <span className="menu-label">  {subItem.label}  </span>
                                            </NavLink>
                                          ))
                                        )}
                                      </div> : null}
                                  </>)}
                              </span>
                            </>
                          )
                        })}
                      </div>
                    )}
                  </div>
                </li>
              )}
            </span>
          )
        })}

      </ul>
    </div>
  )
}

const mapStateToProps = ({ UserReducer, getPermissionActive, UserRollPermission, ClientDataReducer }) => ({ UserReducer, getPermissionActive, UserRollPermission, ClientDataReducer });
const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loginAction,
    editClientData,
    refreshUserAction
  }, dispatch)
);
export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);

